var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 66.1883C50.75 66.1883 50.5 66.1383 50.265 66.0383C49.685 65.7908 36 59.8308 36 47.5733V37.5283C36 36.7258 36.51 36.0133 37.2725 35.7533L50.3975 31.2883C50.7875 31.1558 51.2125 31.1558 51.6025 31.2883L64.7275 35.7533C65.49 36.0133 66 36.7258 66 37.5283V47.5733C66 59.8308 52.315 65.7908 51.735 66.0408C51.5 66.1383 51.25 66.1883 51 66.1883ZM39.75 38.8708V47.5708C39.75 55.9033 48.39 60.9133 51 62.2333C53.61 60.9133 62.25 55.9033 62.25 47.5708V38.8708L51 35.0433L39.75 38.8708Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3744 54.9388C49.8794 54.9388 49.3994 54.7438 49.0494 54.3888L44.0494 49.3888C43.3169 48.6563 43.3169 47.4688 44.0494 46.7363C44.7819 46.0038 45.9694 46.0038 46.7019 46.7363L50.1744 50.2088L56.3744 41.9388C56.9894 41.1113 58.1694 40.9413 58.9994 41.5663C59.8269 42.1863 59.9944 43.3613 59.3719 44.1913L51.8719 54.1913C51.5469 54.6263 51.0494 54.8963 50.5044 54.9363C50.4619 54.9363 50.4194 54.9388 50.3744 54.9388Z",
    fill: "#F30002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.475 57.439H12.875C9.77286 57.439 7.25 54.9161 7.25 51.814V13.064C7.25 9.96182 9.77286 7.43896 12.875 7.43896H41.625C44.7271 7.43896 47.25 9.96182 47.25 13.064V26.639C47.25 26.9836 46.9696 27.264 46.625 27.264C46.2804 27.264 46 26.9836 46 26.639V13.064C46 10.6511 44.0379 8.68896 41.625 8.68896H12.875C10.4621 8.68896 8.5 10.6511 8.5 13.064V51.814C8.5 54.2268 10.4621 56.189 12.875 56.189H32.475C32.8196 56.189 33.1 56.4693 33.1 56.814C33.1 57.1586 32.8196 57.439 32.475 57.439Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.125 28.689H15.375C15.0304 28.689 14.75 28.4086 14.75 28.064C14.75 27.7193 15.0304 27.439 15.375 27.439H39.125C39.4696 27.439 39.75 27.7193 39.75 28.064C39.75 28.4086 39.4696 28.689 39.125 28.689Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 38.689H15.375C15.0304 38.689 14.75 38.4086 14.75 38.064C14.75 37.7193 15.0304 37.439 15.375 37.439H29.125C29.4696 37.439 29.75 37.7193 29.75 38.064C29.75 38.4086 29.4696 38.689 29.125 38.689Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 18.689H15.375C15.0304 18.689 14.75 18.4086 14.75 18.064C14.75 17.7193 15.0304 17.439 15.375 17.439H26.625C26.9696 17.439 27.25 17.7193 27.25 18.064C27.25 18.4086 26.9696 18.689 26.625 18.689Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.1817890930d091911dea5e6b3c9664c9.svg";
export { ForwardRef as ReactComponent };